<div class="">
  <div>
    <div class="modal-body p-0">
      <button type="button" #closebutton class="close" (click)="closeAction()">
        <span aria-hidden="true">×</span>
      </button>
      <div class="mb_34 text-center">
        <img src="assets/images/logout_session.svg" alt="logout-img" class="disclaimer-img">
      </div>
      <div class="text-center">
        <span class="font_30  lineheight_44  fw-bold Aed-add-text mb_5 ">
          {{ 'ErrorOccurredin' | translate }} {{ getErrorDetails.apiCategory | translate }}
        </span>
      </div>
      <div class="text-center">
        <span class="font_24  lineheight_44  fw-bold Aed-add-text mb_5 ">
          {{ 'PleasecontactAdministrator...!!' | translate }}
        </span>
      </div>
      <div class="text-center">
        <span class="font_16  lineheight_44  fw-bold Aed-add-text mb_5 cursor-pointer text-underline" (click)="viewErrorDetails()">
          {{ 'Clickheretoviewthedetails!!' | translate }}
        </span>
      </div>

      <div class="text-center" *ngIf="isviewDetailsClicked">
        <h5 class="font_16   fw-normal Aed-add-text " >
          {{ 'APIName' | translate }}: {{ getErrorDetails.errorAPIName | translate }}
        </h5>
        <h5 class="font_16   fw-normal Aed-add-text" >
          {{ 'ErrorDetails' | translate }}: {{ getErrorDetails.errorMessage | translate }}
        </h5>
      </div>

      <div class="pl-0 mt_30 text-right">
        <div class="d-flex align-items-center justify-content-around w-100">
          <button class="agree agree-pad active font_32 fw-semi ok_btn_padding" (click)="closeAction()">{{ 'Ok' | translate }}</button>
        </div>
      </div>
    </div>
  </div>
</div>
